/* eslint-disable */
/* prettier-ignore */

export const TRANSLATIONS_FR = {
  "  Checked by (signature)": "Vérifié par (signature)",
  "! 3 of 4 types required:": "! 3 types sur 4 requis :",
  "! Min. 14 characters": "! Min. 14 caractères",
  "! No name/username parts": "! Sans parties du nom/nom d'utilisateur",
  "! No spaces": "! Sans espaces",
  "/ occasion": "/ occasion",
  "A new password should be different than the current one": "Un nouveau mot de passe doit être différent du mot de passe actuel.",
  "ACCEPTED": "ACCEPTÉ",
  "Active flights": "Vols actifs",
  "Add deicing/anti-icing": "Ajouter dégivrage/antigivrage",
  "Add description": "Ajouter une description",
  "Add description if there is a irregularity!": "Ajoutez une description s'il y a une anomalie!",
  "Add line": "Ajouter une ligne",
  "Add location where item was found": "Ajouter le lieu où l'objet a été trouvé",
  "Add note": "Ajouter une note...",
  "add occasion": "ajouter une occasion",
  "Add other location": "Ajouter un autre emplacement",
  "Add row": "Ajouter une colonne",
  "Add storage location": "Ajouter le lieu de stockage",
  "Add your recovery email so we can send you a code if you ever forget your password.": "Ajoute ton e-mail de récupération pour qu'on puisse t'envoyer un code si tu oublies ton mot de passe.",
  "additional services": "Prestations supplémentaires",
  "After clicking 'CONFIRM', the correction MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "Après avoir cliqué sur 'CONFIRMER', la correction MVT sera envoyée. Elle peut être renvoyée s'il y a un changement dans ALDT ou/et AIBT.",
  "After clicking 'CONFIRM', the MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "Après avoir cliqué sur 'CONFIRMER', le MVT sera envoyé. Il peut être renvoyé s'il y a un changement dans ALDT ou/et AIBT.",
  "Agent's name:": "Nom de l'agent:",
  "Agent's signature:": "Signature de l'agent:",
  "Aircraft Damage": "Dommages aux aéronefs",
  "Aircraft type": "Type d'avion",
  "Airline": "Compagnie aérienne",
  "All": "Tous",
  "ALL": "TOUS",
  "All Airlines with Stocks": "Toutes les compagnies avec stocks",
  "An error occurred while trying to verify your email address.": "Une erreur s'est produite lors de la tentative de vérification de votre adresse email.",
  "and": " et ",
  "and/or": "et/ou",
  "Anti-icing": "Antigivrage",
  "Any email with @aviapartner.aero or @aviavip.com is not accepted!": "Tout email avec @aviapartner.aero ou @aviavip.com n'est pas accepté !",
  "APPLY": "APPLIQUER",
  "approved": "approuvé",
  "Apr": "Avr",
  "Archived": "Archivé",
  "Are you sure you want to change your password?": "Êtes-vous sûr de vouloir modifier votre mot de passe ?",
  "Are you sure you want to exit the current process?": "Êtes-vous sûr de vouloir quitter le processus en cours ?",
  "Are you sure you want to remove photo?": "Vous êtes sûr de vouloir supprimer la photo ?",
  "Are you sure you want to sign out?": "Voulez-vous vraiment vous déconnecter?",
  "area": "zone",
  "Arrival MVT has been sent": "MVT Arrivée envoyé avec succès",
  "Arrival MVT not sent yet": "Le MVT d'arrivée n'a pas encore été envoyé",
  "Arrival MVT sending": "Envoi du MVT d'arrivée",
  "Arrival MVT sent successfully": "MVT Arrivée envoyé avec succès",
  "Attach photo": "Joindre une photo",
  "Attachment": "Pièce jointe",
  "Aug": "Aoû",
  "Available": "Disponible",
  "Belt": "Convoyeur",
  "Body": "Fuselage",
  "Briefly describe where the item will be stored for picking up.": "Décrivez brièvement l'endroit où l'objet sera stocké avant d'être récupéré.",
  "Call {{firstName}} {{lastName}}": "Appeler {{firstName}} {{lastName}}",
  "Call sign": "Indicatif d'appel",
  "Cancel": "Annuler",
  "CANCEL": "ANNULER",
  "Cannot be after": "Ne peut pas être après",
  "Cannot be before": "Ne peut pas être avant",
  "Cannot create MVT message: missing flight information": "Impossible de créer un message MVT: informations de vol manquantes",
  "Cannot send Arrival MVT": "Impossible d'envoyer le MVT d'arrivée. Les adresses (SITA et/ou e-mail) pour ce vol ne sont pas configurées dans Sunrise.",
  "Cannot send Arrival MVT. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Impossible d'envoyer l'arrivée MVT. Les adresses (SITA et/ou email) pour ce vol ne sont pas configurées dans Sunrise.",
  "Cannot send MVT ETD": "Impossible d'envoyer le MVT ETD. Les adresses (SITA et/ou e-mail) pour ce vol ne sont pas configurées dans Sunrise.",
  "Cannot send MVT ETD. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Impossible d'envoyer MVT ETD. Les adresses (SITA et/ou email) pour ce vol ne sont pas configurées dans Sunrise.",
  "Cannot set a future time.": "Une heure future n'est pas autorisée.",
  "Change": "Modifier",
  "Change password": "Modifier le mot de passe",
  "Change password?": "Changer le mot de passe ?",
  "Change your password:": "Modifier votre mot de passe :",
  "Checked by (signature)": "Vérifié par (signature)",
  "Checks on easily visible parts of the aircraft from the ground": "Vérifiez les parties facilement visibles de l'avion à partir du sol. Aucun dommage évident ni anomalie sur:",
  "Checks on easily visible parts of the aircraft from the ground. No obvious damage or anomalies to:": "Vérifiez les parties facilement visibles de l'avion depuis le sol. Aucun dommage ou anomalie évident à :",
  "Chocks": "Cales",
  "Chute": "Chute",
  "CLEAR": "EFFACER",
  "Client's signature:": "Signature du client:",
  "Clocked Time": "Heure pointée",
  "Close": "Fermer",
  "CLOSE": "FERMER",
  "Close all my sessions on all devices": "Fermer toutes mes sessions sur tous les appareils",
  "Close registration": "Fermer l'enregistrement",
  "CLOSE REGISTRATION": "FERMER L'ENREGISTREMENT",
  "close the flight": "fermer le vol",
  "Closed": "Fermé",
  "Closing this window will discard all your recent changes.": "Fermer cette fenêtre annulera toutes vos modifications récentes.",
  "Clouds": "Nuages",
  "Comment": "Commentaire",
  "Comment...": "Commentaire...",
  "Comments": "Commentaires",
  "Completed": "Effectué",
  "Conditional services": "Services conditionnels",
  "Cones": "Cônes",
  "CONFIRM": "CONFIRMER",
  "Confirm": "Confirmer",
  "Confirm new password": "Confirmez le nouveau mot de passe",
  "Confirm remove?": "Confirmer la suppression ?",
  "CONFIRMED": "CONFIRMÉ",
  "Contact your administrator to request access": "Contactez votre administrateur pour demander l'accès",
  "Could not save data, please try again later": "Impossible de sauvegarder les données, veuillez réessayer plus tard",
  "Crew signature": "SIGNATURE CREW",
  "Current password": "Mot de passe actuel",
  "Damage": "Dégâts",
  "Date range": "Plage de dates",
  "Date should not be before start date": "La date ne doit pas être antérieure à la date de début",
  "Day": "Jour",
  "Dec": "Déc",
  "DECLINED": "DÉCLINÉ",
  "Default station": "Station par défaut",
  "Deicing": "Dégivrage",
  "Deicing Service Registration": "Enregistrement du service de dégivrage",
  "Delete Photo": "Supprimer la photo",
  "DENIED": "REJETÉ",
  "Describe location": "Décrire l'emplacement",
  "Dest.": "Dest.",
  "Destination": "Destination",
  "Did you forget something?": "Avez-vous oublié quelque chose ?",
  "Don't use phone while driving!": "Ne pas utiliser le téléphone en conduisant !",
  "Dummy Type": "Type de mannequin",
  "Edit Comment": "Modifier le commentaire",
  "Emergency": "Urgence",
  "Emergency contacts are not set up": "Les contacts d'urgence ne sont pas configurés.",
  "employees": "employés",
  "End": "Fin",
  "End of anti-icing": "Fin de l'antigivrage",
  "End Time": "Heure de fin",
  "End time should not be before start time": "L'heure de fin ne doit pas être antérieure à l'heure de début",
  "Entrance": "Entrée",
  "Error loading clocked times": "Erreur de chargement des heures pointées",
  "Error. The email doesn't meet standard formatting.": "Erreur. L'email ne respecte pas le format standard.",
  "exceeds the allowed limit for this flight": " dépasse la limite autorisée pour ce vol.",
  "Executor's name:": "Nom de l'exécutant :",
  "Executor's signature:": "Signature de l'exécutant :",
  "extra service": "Service supplémentaire",
  "Extra services": "Services supplémentaires",
  "Extra shift request": "Demande de poste supplémentaire",
  "Extra Shift Request": "Demande de poste supplémentaire",
  "Extra shift request confirmed": "Demande de poste supplémentaire confirmée",
  "failed": "Echec",
  "Feb": "Fév",
  "Filter": "Filtrer",
  "Filter group": "Groupe de filtres",
  "Filter group has not been updated": "Le groupe de filtres n'a pas été mis à jour",
  "filter group not found": "groupe de filtres non trouvé",
  "finalization": "finalisation",
  "Find the account recovery section and click \"Resend verification email\".": "Trouvez la section de récupération de compte et cliquez sur \"Renvoyer l'email de vérification\".",
  "FirebaseError: A document cannot be written because it exceeds the  maximum size allowed": "FirebaseError : Un document ne peut être écrit car il dépasse la taille maximale autorisée",
  "FirebaseError: A document cannot be written because it exceeds the maximum size allowed": "FirebaseError : Un document ne peut pas être écrit car il dépasse la taille maximale autorisée.",
  "Flight": "Vol",
  "Flight details": "Détails du vol",
  "Flight information registration": "Enregistrement des informations de vol",
  "Flight not found": "Vol introuvable",
  "Flight number/registration": "Numéro de vol/enregistrement",
  "Flight registration is closed": "l'enregistrement du vol est clos.",
  "Flight reopened": "Vol rouvert",
  "Flight type": "Type de vol",
  "Flights": "Vols",
  "Fluid name": "Nom du fluide :",
  "Fluid name:": "Nom du fluide :",
  "Fluid type": "Type de fluide",
  "Forgot your password?": "Mot de passe oublié ?",
  "Forms": "Formulaires",
  "from": "de",
  "From": "De",
  "Full (Wings, stabilizer &, fuselage)": "Complet (Ailes, stabilisateur et fuselage)",
  "Future time is not allowed": "Une heure future n'est pas autorisée",
  "Gate": "Porte",
  "General info": "Informations générales",
  "Go to flights": "Aller aux vols",
  "Go to login": "Aller à la connexion",
  "Go to My Profile in your Sunrise account.": "Allez dans Mon Profil dans votre compte Sunrise.",
  "Go to Unread R&S": "Aller aux R&S Non lus",
  "Helpdesk": "Service d'assistance",
  "Hold Inspection on Arrival": "Maintenir l'inspection à l'arrivée",
  "Hold Inspection on Departure": "Inspection des soutes départ",
  "hr": "h",
  "Humidity": "Humidité",
  "If damage is found, mark it on the sketch": "Si des dommages sont trouvés, marquez-les sur le croquis",
  "If the problem continues, go to My Profile to resend a new verification link.": "Si le problème persiste, allez dans Mon Profil pour renvoyer un nouveau lien de vérification.",
  "In order to close this flight you need to provide": "Pour fermer ce vol, vous devez fournir les informations obligatoires.",
  "In order to close this flight you need to provide mandatory details.": "Pour fermer ce vol, vous devez fournir des informations obligatoires.",
  "In order to open 'Calendar', read and process recent Read & Sign messages.": "Pour ouvrir le 'Calendrier', lisez et validez les récentes notes de services.",
  "In order to send Arrival MVT you need to provide mandatory details": "Pour envoyer le MVT d'arrivée, vous devez saisir les informations obligatoires.",
  "Include nearby area": "Inclure la zone proche",
  "Included nearby area": "Inclus dans la zone proche",
  "Incorrect code": "Code incorrect",
  "Input a brief description here": "Saisissez une brève description ici",
  "Inspected by": "Inspecté par",
  "Inspection agent's signature": "Signature de l'agent d'inspection",
  "Inspection agent's signature:": "Signature de l'agent d'inspection:",
  "Inspections": "Inspections",
  "Instructions": "Instructions",
  "Internal communication": "Communication interne",
  "Invalid ALDT/AIBT value or Arrival MVT with such ALDT and AIBT values already exist": "Valeur ALDT/AIBT non valide ou MVT d'arrivée avec de telles valeurs ALDT et AIBT existe déjà",
  "is logged in": "est connecté",
  "Is Partial": "Partiel",
  "is signed in": "Est connecté",
  "It's safe and encrypted - only used for password resets.": "C'est sécurisé et crypté — utilisé uniquement pour réinitialiser ton mot de passe.",
  "Jan": "Jan",
  "Job vacancy": "Offre d'emploi",
  "Jul": "Jul",
  "Jun": "Jun",
  "KEY PEOPLE": "PERSONNES CLÉS",
  "Language": "Langue",
  "Leave a comment about this timestamp and connected action.": "Laissez un commentaire sur cet horodatage et l'action connectée.",
  "Left Engine": "Moteur gauche",
  "Left Tail Wing": "Aile arrière gauche",
  "Left Wing": "Aile gauche",
  "Load Verification Cross-Check Form": "Formulaire de réconciliation du chargement",
  "Local (Under Wing / Local area contamination)": "Local (Sous l'aile / Contamination locale)",
  "Local Bags": "Bagages locaux",
  "Locked application": "Application verrouillée",
  "Log in": "Se connecter",
  "Log out": "Déconnexion",
  "Lost item": "Objet perdu",
  "lowercase": "minuscules",
  "Mar": "Mar",
  "Mark location": "Marquer l'emplacement",
  "May": "Mai",
  "Message archived": "Message archivé",
  "Message state": "État du message",
  "Message type": "TYPE DE MESSAGE",
  "Message unarchived": "Message non archivé",
  "Messages": "Messages",
  "messages yet": "Messages pour le moment",
  "min": "min",
  "Mix": "Mélange",
  "Month": "Mois",
  "MVT History": "Historique MVT",
  "My profile": "Mon profil",
  "Name Surname": "Nom Prénom",
  "Neck": "Cou",
  "New password": "Nouveau mot de passe",
  "New password cannot be equal to current": "Le nouveau mot de passe ne peut pas être identique à l'actuel.",
  "New password does not meet security requirements": "Le nouveau mot de passe ne respecte pas les exigences de sécurité",
  "next": "suivant",
  "Next 5 days": "5 prochains jours",
  "No": "Non",
  "No active flights yet": "Aucun vol actif pour le moment",
  "No clocked times available": "Aucune heure pointée disponible",
  "No content yet...": "Pas encore de contenu...",
  "No flight details information": "Aucune information sur les détails du vol",
  "No instructions found": "Aucune instruction trouvée",
  "No internet connection": "Pas de connexion internet",
  "No key people assigned.": "Aucune personne clé assignée.",
  "No messages yet": "Aucun message pour le moment",
  "No photo available": "Aucune photo disponible",
  "No photos here yet": "Aucune photo ici pour le moment",
  "No registration": "Aucune inscription",
  "No services available": "Aucun service disponible",
  "No time logging found": "Aucun enregistrement de temps trouvé",
  "No timestamps configured for this flight type": "Aucun horodatage configuré pour ce type de vol",
  "No types here yet": "Aucun type ici pour le moment",
  "no user data": "aucune donnée utilisateur",
  "None": "Aucun",
  "Nose": "Nez",
  "Not completed": "Non effectué",
  "Note": "Remarque:",
  "Nov": "Nov",
  "NOW": "MAINTENANT",
  "Number of unread R&S:": "Nombre de R&S non lus:",
  "numbers": "chiffres",
  "occasion": "occasion",
  "Occasion": "Occasion",
  "Oct": "Oct",
  "Oops! It looks like your verification email didn't go through.": "Oups ! Il semble que votre email de vérification n'ait pas abouti.",
  "Open": "Ouvert",
  "Open a flight to add it to your active flights list.": "Ouvrez un vol pour l'ajouter à votre liste de vols actifs.",
  "Open file": "Ouvrir le dossier",
  "Open flight {{name}}": "Ouvrir le vol {{name}}",
  "Operation flight number": "Numéro de vol opérationnel",
  "Operator's name": "Nom de l'opérateur",
  "Operator's name:": "Nom de l'opérateur :",
  "Operator's signature": "Signature de l'opérateur",
  "Operator's signature:": "Signature de l'opérateur :",
  "Optional": "Facultatif",
  "or": "ou",
  "Origin": "Origine",
  "Other flights": "Autres vols",
  "Outside Air Temperature": "Température de l'air extérieur (C°)",
  "Outside Air Temperature (C°)": "Température de l'air extérieur (C°)",
  "Page not found": "Page introuvable",
  "Parking": "Parking",
  "Partially (Wings & stabilizer only)": "Partiel (Ailes et stabilisateur uniquement)",
  "Password": "Mot de passe",
  "Password must be at least 8 characters": "Le mot de passe doit comporter au moins 8 caractères et contenir au moins 1 lettre majuscule et 1 lettre minuscule, 1 symbole, 1 chiffre et aucun espace.",
  "Password Not Unique. Your new password cannot be one of your last 5 used passwords.": "Mot de passe non unique. Votre nouveau mot de passe ne peut pas être l'un de vos 5 derniers mots de passe utilisés.",
  "Passwords do not match": "Les mots de passe ne correspondent pas",
  "per occasion": "par occasion",
  "Per pax": "Par pax",
  "per start": "par démarrage",
  "percent": "pourcent",
  "Photo registration": "Enregistrement des photos",
  "Photo types required": "Types de photos requis",
  "Photo types required:": "Types de photos requis :",
  "Photos": "Photos",
  "Pick if its a damaged part or lost item": "Choisissez s'il s'agit d'une pièce endommagée ou d'un objet perdu",
  "Pin on schema": "Pointer sur le schéma",
  "Please briefly describe where you found the item": "Veuillez décrire brièvement où vous avez trouvé l'article. Précisez la pièce ou la ligne et la rangée si disponible",
  "Please click here to proceed to flights list": "Veuillez cliquer ici pour accéder à la liste des vols",
  "Please make sure you attached photos of irregularities": "Vérifiez que vous avez joint des photos des anomalies",
  "Please pick on scheme": "Veuillez sélectionner un shéma",
  "Please reach out to your administrator for assistance": "Veuillez contacter votre administrateur pour obtenir de l'aide.",
  "Please try sending it again later.": "Veuillez essayer de l'envoyer à nouveau plus tard.",
  "Please try the link again.": "Veuillez réessayer le lien.",
  "Please, sign below": "Veuillez signer ci-dessous",
  "Post-deicing/anti-icing check completed": "Contrôle après dégivrage/antigivrage effectué",
  "Precipitation": "Précipitations",
  "Pressure": "Pression",
  "Proceed to login": "Procéder à la connexion",
  "Product name": "Nom du produit",
  "Product type": "Type de produit",
  "Profile": "Profil",
  "Profile data wasn't updated!": "Les données du profil n'ont pas été mises à jour ! ",
  "Psychosocial aid": "Aide psychosociale",
  "Quantity (liter)": "Quantité (litre)",
  "Read": "Lu",
  "Read & Sign": "Lire et signer",
  "Read & Sign to do:": "Lire et signer pour faire :",
  "Read&Sign": "Lire et signer",
  "Receive Extra shift requests": "Recevoir des demandes de quart supplémentaire",
  "Receive job vacancies": "Recevoir les offres d'emploi",
  recovery: {
    "error1": "<1>Oups !</1> Il semble que votre e-mail de vérification n'ait pas été envoyé.",
    "error2": "<1>Veuillez réessayer plus tard.</1>",
    "error3": "Nous nous excusons pour la gêne occasionnée.",
    "inUse": "Cet e-mail de récupération est déjà <1>utilisé !</1>",
    "success": "L'<1>e-mail de vérification</1> a été envoyé avec succès !",
    validation: {
      "blockedDomainNote": "tout e-mail avec <1>@aviapartner.aero</1> ou <3>@aviavip.com</3> n'est pas accepté !",
      "invalidFormat": "Erreur. L'e-mail ne respecte pas le format standard."
    },
    "verified": "Votre e-mail de récupération est déjà <1>vérifié !</1>"
  },
  "Recovery email": "E-mail de récupération",
  "Recovery email already verified!": "Email de récupération déjà vérifié !",
  "Recovery email verified!": "Email de récupération vérifié !",
  "Reg.": "Immat.",
  "Registration": "Immatriculation",
  "Registration Closed": "Enregistrement fermé",
  "REGISTRATION CLOSED": "ENREGISTREMENT FERMÉ",
  "registration complete": "enregistrement terminé",
  "Remark": "Remarque",
  "Remove": "Retirer",
  "Remove {{name}} from active flights": "Retirer {{name}} des vols actifs",
  "Reopen": "Rouvrir",
  "reopen flight": "réouverture du vol",
  "Report any irregularities found upon arrival": "Signaler toute irrégularité constatée à l'arrivée",
  "Report any other irregularities": "Signaler toute autre irrégularité",
  "Required": "Requis",
  "required to close the flight": "La fermeture du vol est demandée",
  "Requirements of the password are not met.": "Les exigences du mot de passe ne sont pas remplies.",
  "Resend verification email": "Renvoyer l'e-mail de vérification",
  "Right Engine": "Moteur droit",
  "Right Tail Wing": "Aile arrière droite",
  "Right Wing": "L'aile droite",
  "Runway": "Piste",
  "Safety Ramp Checklist": "Liste de contrôle de la rampe de sécurité",
  "Safety Ramp Inspection": "Inspection de la rampe de sécurité",
  "SAVE": "Enregistrer",
  "save": "enregistrer",
  "Save service registrations problem": "Sauvegarder le problème des enregistrements de service",
  "Screening": "Dépistage",
  "Search": "Rechercher",
  "Seat": "Siège",
  "Seats": "Sièges",
  "Select type": "Sélectionnez un type",
  "SEND ARRIVAL MVT": "ENVOYER LE MVT D'ARRIVÉE",
  "SEND CORRECTION ARRIVAL MVT": "ENVOYER LA CORRECTION DU MVT D'ARRIVÉE",
  "Send the Arrival MVT message to recipients:": "Envoyez le message MVT d'arrivée aux destinataires:",
  "SENT": "ENVOYÉ",
  "Sep": "Sep",
  "Service info saved": "Informations sur le service sauvegardées",
  "Service registration": "Enregistrement du service",
  "Service registration is closed": "L’enregistrement du vol est clos.",
  "Service Type": "Type de service",
  "Set": "Définir",
  "Set date": "Définir la date",
  "Set time": "Définir l'heure",
  "Set time: End of anti-icing": "Définir l'heure : Fin de l'antigivrage",
  "Set to now": "Définir à maintenant",
  "Short remark": "Remarque courte",
  "Show": "Afficher",
  "Show Photo": "Afficher la photo",
  "Sign for understanding": "Signer si vous avez compris",
  "Sign form below to complete it": "Signez le formulaire ci-dessous pour le terminer:",
  "Sign in": "Se connecter",
  "Sign out": "Déconnexion",
  "Signed": "Signé",
  "SKIP": "PASSER",
  "Skip this step": "Passer cette étape",
  "Something went wrong": "Une erreur s'est produite",
  "Something went wrong. Please try again later.": "Une erreur s'est produite. Veuillez réessayer plus tard.",
  "Something wrong": "Une erreur s'est produite",
  "Sort.": "Trier.",
  "Specify where did you found the item": "Indiquez où vous avez trouvé l'objet",
  "Start": "Début",
  "Start anti-icing": "Début antigivrage",
  "Start Time": "Heure de début",
  "Station": "Station",
  "Stations": "Stations",
  "Stop anti-icing": "Fin antigivrage",
  "success": "succès",
  "Sunrise": "Lever de soleil",
  "Sunset": "Coucher de soleil",
  "Switch flight": "Changer de vol",
  "symbols": "symboles",
  "SYSTEM SETTINGS": "PARAMÈTRES DU SYSTÈME",
  "Tail": "Queue",
  "Take a photo": "Prenez une photo",
  "Take a photo of a finished action, this timestamp is dedicated to.": "Prenez une photo d'une action terminée, cet horodatage est dédié à.",
  "Tap on area where damaged part is located": "Tapez sur la zone où se trouve la partie endommagée",
  "Task": "Tâche",
  "Tasks & Flights": "Tâches & Vols",
  "Telex messages": "Messages Telex",
  "Temperature (C°)": "Température (C°)",
  "The app has been updated": "L'application a été mise à jour",
  "The APPI code is required when resetting your Aviapartner": "Le code APPI est nécessaire pour réinitialiser le mot de passe de votre compte Aviapartner dans Sunrise ou par le biais du service d'assistance Aviapartner. Vous pouvez toujours trouver votre code APPI dans votre profil dans Sunrise.",
  "The APPI code is required when resetting your Aviapartner account password in Sunrise or through the Aviapartner helpdesk. You can  always find your APPI code in your profile in Sunrise.": "Le code APPI est nécessaire pour réinitialiser le mot de passe de votre compte Aviapartner dans Sunrise ou par le biais du service d'assistance Aviapartner. Vous pouvez toujours trouver votre code APPI dans votre profil dans Sunrise.",
  "the correction MVT will be sent": "Après avoir cliqué sur 'CONFIRMER', le message de correction du MVT sera envoyé. Il peut être renvoyé en cas de modification de l'ALDT ou/et de l'AIBT.",
  "The current password you entered is incorrect.": "Le mot de passe actuel saisi est incorrect.",
  "The current password you've entered is incorrect": "Le mot de passe actuel que vous avez saisi est incorrect. Veuillez le vérifier et réessayer.",
  "The elapsed time between": "Le temps écoulé entre ",
  "The end time must be later than the start time.": "L'heure de fin doit être postérieure à l'heure de début.",
  "the MVT will be sent": "Après avoir cliqué sur 'CONFIRMER', le MVT sera envoyé. Il peut être renvoyé en cas de modification de l'ALDT ou/et de l'AIBT.",
  "The planning shown below might not be up-to-date": "Le planning ci-dessous n'est peut-être pas à jour.",
  "The shift is already confirmed to": "La vacation est déjà confirmée à",
  "The username or password you've entered is incorrect": "Le nom d'utilisateur ou le mot de passe que vous avez saisi est incorrect. Veuillez vérifier à nouveau et réessayer.",
  "The username or password you've entered is incorrect. Please  double-check and try again.": "Le nom d'utilisateur ou le mot de passe que vous avez saisi est incorrect. Veuillez vérifier à nouveau et réessayer.",
  "The verification email has been sent successfully!": "L'email de vérification a été envoyé avec succès !",
  "This action is mandatory.": "Cette action est obligatoire.",
  "This field is mandatory": "Ce champ est obligatoire",
  "This form is signed": "Ce formulaire est signé",
  "This message is marked as urgent": "Ce message est marqué comme urgent",
  "This recovery email is already in use!": "Cet email de récupération est déjà utilisé !",
  "This request is not valid anymore": "Cette demande n'est plus valable",
  "This section is used to deal with visible damage to the airplane": "Cette section est utilisée pour traiter les dommages visibles de l'avion. Veuillez documenter chaque problème visible avant d'effectuer tout service.",
  "This service has been registered for this flight over 80% of the time.": "Ce service a été enregistré pour ce vol plus de 80% du temps.",
  "time": " heure.",
  "Time registration": "Enregistrement des heures",
  "Timeline": "Chronologie",
  "Timestamp information": "Informations sur l'horodatage",
  "Timestamps type": "Type d'horodatage",
  "to": "à",
  "To get a new one, simply follow these steps:": "Pour en obtenir un nouveau, suivez simplement ces étapes :",
  "Today": "Aujourd'hui",
  "TODAY": "AUJOURD'HUI",
  "Tomorrow": "Demain",
  "Transfer Bags": "Bagages de transfert",
  "Truck Driver": "Chauffeur de camion",
  "Truck driver's signature": "Signature du conducteur du camion",
  "Truck driver's signature:": "Signature du chauffeur du camion:",
  "Truck Number": "Numéro de camion",
  "type": "type",
  "Type": "Type",
  "Unavailable": "Indisponible",
  "Unread": "Non lu",
  "Until": "Jusqu'à",
  "Unverified email": "E-mail non vérifié !",
  "uppercase": "majuscules",
  "Username": "Nom d'utilisateur",
  "Username or email": "Nom d'utilisateur ou email",
  "validating": "validation en cours",
  "validation": "validation",
  "Verification Error": "Erreur de vérification",
  "Verification Link Expired": "Lien de vérification expiré",
  "Verified email": "E-mail vérifié",
  verify: {
    "alreadyVerifiedTitle": "E-mail de récupération déjà vérifié !",
    "error1": "Une erreur s'est produite lors de la tentative de vérification de votre adresse e-mail.",
    "error2": "Veuillez réessayer le lien.",
    "error3": "Si le problème persiste, accédez à <1>Mon profil</1> pour renvoyer un nouveau lien de vérification.",
    "errorTitle": "Erreur de vérification",
    "expiredStep1": "Accédez à <1>Mon profil</1> dans votre compte Sunrise.",
    "expiredStep2": "Trouvez la section de récupération de compte et cliquez sur \"Renvoyer l'e-mail de vérification\".",
    "expiredStepsIntro": "Pour en obtenir un nouveau, suivez simplement ces étapes :",
    "expiredTitle": "Lien de vérification expiré",
    "successDescription": "Vous pouvez maintenant l'utiliser pour accéder à votre compte si vous oubliez votre mot de passe.",
    "successTitle": "E-mail de récupération vérifié !",
    "verifying": "Vérification..."
  },
  "Verifying...": "Vérification...",
  "View key people": "Voir les personnes clés",
  "Visibility": "Visibilité",
  "Visual checks must be performed AFTER GSE removal": "Les vérifications visuelles doivent être effectuées APRES le retrait du matériel",
  "Visual checks must be performed BEFORE GSE positioning": "Les vérifications visuelles doivent être effectuées AVANT la mise en place du matériel",
  "Walkaround Arrival Checklist": "Liste de contrôle Tour avion arrivée",
  "Walkaround Pre-Departure Checklist": "Liste de contrôle Tour avion avant départ",
  "We apologize for the inconvenience.": "Nous nous excusons pour le désagrément.",
  "We strongly recommend saving it in your smartphone phonebook": "Nous vous recommandons vivement de l'enregistrer dans le répertoire de votre smartphone afin d'avoir toujours le code APPI à portée de main. Pour enregistrer le code, rendez-vous sur votre profil Sunrise et scannez le code QR avec votre smartphone.",
  "We strongly recommend saving it in your smartphone phonebook so that you always have the APPI code at hand. To save the code, go to your Sunrise profile and scan the QR code with your smartphone.": "Nous vous recommandons vivement de l'enregistrer dans le répertoire de votre smartphone afin d'avoir toujours le code APPI à portée de main. Pour enregistrer le code, rendez-vous sur votre profil Sunrise et scannez le code QR avec votre smartphone.",
  "Weather": "Météo",
  "Wind": "Vent",
  "Would you like to add it to your current registration?": "Souhaitez-vous l'ajouter à votre enregistrement actuel ?",
  "Write comment": "Écrire un commentaire",
  "write new comment": "écrire un nouveau commentaire",
  "Write your comment here, then press the green check mark": "Écrivez votre commentaire ici, puis cochez la case verte.",
  "Year": "Année",
  "Yes": "Oui",
  "Yesterday": "Hier",
  "You are offline": "Vous êtes hors ligne.",
  "You can check your APPI code on Sunrise portal.": "Vous pouvez vérifier votre code APPI sur le portail Sunrise.",
  "You can now use it to regain access to your account if you forget your password.": "Vous pouvez maintenant l'utiliser pour retrouver l'accès à votre compte si vous oubliez votre mot de passe.",
  "You can't remove this temporal item": "Vous ne pouvez pas supprimer cet élément temporaire",
  "You don't have permission to view clocked times": "Vous n'avez pas l'autorisation de voir les heures pointées",
  "You don't have permissions to take a photo": "Vous n'avez pas l'autorisation de prendre une photo.",
  "You were signed out automatically": "Vous avez été déconnecté automatiquement. Le jeton a expiré. Vous pouvez vous reconnecter avec vos identifiants.",
  "Your password and confirmation password do not match": "Votre mot de passe et le mot de passe de confirmation ne correspondent pas.",
  "Your password has been changed successfully!": "Votre mot de passe a été changé avec succès !",
  "Your password has expired. Please compose a new password and log in again.": "Votre mot de passe a expiré. Veuillez composer un nouveau mot de passe et vous connecter à nouveau.",
  "Your password must contain at least eight characters": "Votre mot de passe doit contenir au moins huit caractères, au moins un chiffre et des lettres minuscules et majuscules. ",
  "Your password must contain at least eight characters, at least one number and both lower and uppercase letters.": "Votre mot de passe doit contenir au moins huit caractères, au moins un chiffre et à la fois des lettres minuscules et majuscules.",
  "Your recovery email is already verified!": "Votre email de récupération est déjà vérifié !",
  "Your session has expired. Please sign in again.": "Votre session a expiré. Veuillez vous reconnecter."
};
